import script from "./details.vue?vue&type=script&setup=true&name=ZoomEmailCalendarDetails&lang=js"
export * from "./details.vue?vue&type=script&setup=true&name=ZoomEmailCalendarDetails&lang=js"

import "./details.vue?vue&type=style&index=0&id=61f41d8f&lang=scss"

const __exports__ = script;

export default __exports__